import React from "react";

function FeatureIcon({ icon }) {
  const s = { fill: "none", stroke: "currentColor", strokeWidth: "1.9", strokeLinecap: "round", strokeLinejoin: "round" };
  const paths = {
    target: (
      <>
        <circle cx="12" cy="12" r="7" {...s} />
        <circle cx="12" cy="12" r="3" {...s} />
        <path d="M12 2v2M12 20v2M2 12h2M20 12h2" {...s} />
      </>
    ),
    clean: (
      <>
        <path d="M5 7h14M5 12h10M5 17h7" {...s} />
        <path d="M18 15l1.5 1.5L22 14" {...s} />
      </>
    ),
    shield: (
      <>
        <path d="M12 3 5 6v5c0 4.4 2.8 8.5 7 10 4.2-1.5 7-5.6 7-10V6l-7-3Z" {...s} />
        <path d="m9.5 12 1.8 1.8L15 10.2" {...s} />
      </>
    ),
    bell: (
      <>
        <path d="M8 17h8l-1.2-1.8V11a4.8 4.8 0 1 0-9.6 0v4.2L8 17Z" {...s} />
        <path d="M10.5 19a1.8 1.8 0 0 0 3 0" {...s} />
      </>
    ),
    bolt: (
      <>
        <path d="M13 2 6 13h5l-1 9 8-12h-5l0-8Z" {...s} />
      </>
    ),
  };
  return <svg viewBox="0 0 24 24" aria-hidden="true">{paths[icon]}</svg>;
}

const features = [
  {
    title: "Smart Zone Identification",
    description: "Surface the trading areas that matter most by reading price structure and zone relevance together.",
    icon: "target",
    color: "blue",
  },
  {
    title: "Clean & Focused Charts",
    description: "Keep the chart readable with a presentation designed to reduce clutter and support faster decisions.",
    icon: "clean",
    color: "green",
  },
  {
    title: "Fresh vs Tested Zones",
    description: "Separate untouched opportunity areas from levels that have already been revisited by price.",
    icon: "shield",
    color: "purple",
  },
  {
    title: "Real-Time Alerts",
    description: "Stay informed when market price returns to important zones so you can react with better timing.",
    icon: "bell",
    color: "orange",
  },
  {
    title: "Built for Boom & Crash",
    description: "The workflow is shaped around Boom & Crash behavior instead of being a generic one-size-fits-all setup.",
    icon: "bolt",
    color: "teal",
  },
];

export default function Features() {
  return (
    <section className="landing-section" id="features">
      <div className="landing-section-heading">
        <div className="landing-eyebrow">Core Features</div>
        <h2>Everything you need to trade with structure.</h2>
        <p>
          Every part of the platform is built to help you spot quality zones faster,
          filter stale levels, and stay focused on what price is doing right now.
        </p>
      </div>

      <div className="landing-feature-grid">
        {features.map((f) => (
          <article key={f.title} className={`landing-feature-card landing-feature-card-${f.color}`}>
            <div className="landing-feature-accent" aria-hidden="true">
              <FeatureIcon icon={f.icon} />
            </div>
            <h3>{f.title}</h3>
            <p>{f.description}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
